window.addEventListener('DOMContentLoaded', function() {
    var historyDateList = document.querySelector('.history-date-list');
    var footer = document.querySelector('footer');
    var menuHeight = 100; // Hauteur du menu sticky en pixels
    var footerThreshold = footer.getBoundingClientRect().top + window.pageYOffset - window.innerHeight;

    function toggleHistoryDateList() {
        if (!historyDateList || !historyDateList.parentElement) {
            return; // Vérifier si historyDateList existe et a un parent
        }

        var containerRect = historyDateList.parentElement.getBoundingClientRect();
        var containerTop = containerRect.top;

        if (window.innerWidth >= 767) {
          if (containerTop <= menuHeight && window.pageYOffset < footerThreshold) {
              historyDateList.style.position = 'fixed';
              historyDateList.style.top = menuHeight + 'px';
          } else {
              historyDateList.style.position = 'absolute';
              historyDateList.style.top = '0';
          }
        }
        else {
            if (containerTop <= menuHeight && window.pageYOffset < footerThreshold) {
                historyDateList.style.position = 'fixed';
                historyDateList.style.top = menuHeight + 'px';
            } 
            else {
                historyDateList.style.position = 'relative';
                historyDateList.style.top = '0';
            }
        }
    }

    function checkFooterThreshold() {
        footerThreshold = footer.getBoundingClientRect().top + window.pageYOffset - window.innerHeight;

        if (window.pageYOffset >= footerThreshold) {
            window.addEventListener('scroll', toggleHistoryDateList);
            window.removeEventListener('scroll', checkFooterThreshold);
        } else {
            toggleHistoryDateList();
        }
    }

    window.addEventListener('scroll', toggleHistoryDateList);
    window.addEventListener('scroll', checkFooterThreshold);
});




